<input class="hide-input-number-arrow" matInput [readonly]="readonly" [mask]="mask"
  [thousandSeparator]="authService.thousandSeparator" [decimalMarker]="authService.decimalMarker"
  [placeholder]="placeholder" [formControl]="amount" [autocomplete]="autocomplete" [maxlength]="maxLength"
  (focus)="onFocus()" (focusout)="onFocusout()">